
import {
  REQUEST_NEWS,
  GET_SINGLE_NEWS,
  EDIT_NEWS,
  REQUEST_NEWS_BY_CATEGORY,
  GET_MOST_READ_NEWS_BY_CATEGORY,
  NEWS_CLOSE_SUCCES_MODAL,
  DELETE_NEWS,
  MOST_READ_NEWS
} from './constants';

/**
 * Request news
 *
 * @param  {string} query limit and offset
 *
 * @return {object} An action object with a type of REQUEST_NEWS
 */

export function requestNews(category: string, page: number, search: string, admin?: boolean) {
  return {
    type: REQUEST_NEWS,
    category,
    page,
    search,
    admin
  };
}

export function requestNewsByCategory(query?: string) {
    return {
      type: REQUEST_NEWS_BY_CATEGORY,
      query,
    };
  }

export function getSingleNews(id: string, admin?: boolean) {
  return {
    type: GET_SINGLE_NEWS,
    id,
    admin
  }
}

// Edit, Create News
export function editNews(data: object) {
  return {
    type: EDIT_NEWS,
    data,
  }
}

// Action Most Read News By Category
export function getMostReadNewsByCategory(category: string, unique_id: string, page: number) {
  return {
    type: GET_MOST_READ_NEWS_BY_CATEGORY,
    category,
    unique_id,
    page
  }
}

export function modalAction(open: boolean) {
  return {
    type: NEWS_CLOSE_SUCCES_MODAL,
    open
  }
}

export function deleteItem(id: string, page?: Number) {
  return {
    type: DELETE_NEWS,
    id,
    page
  }
}

export function getMostReadNews(page: number) {  
  return {
    type: MOST_READ_NEWS,
    page
  };
}


// export function requestNewsAdmin(category: string, page: number, search: string) {
//   return {
//     type: REQUEST_NEWS_ADMIN,
//     category,
//     page,
//     search
//   };
// }
